module.exports = __webpack_public_path__ + "media/music/78a74345ee778afbd6abe637b4f69efc.mp3";